import React from "react";
import { NavLink, withRouter } from "react-router-dom";
import { BoxDanger, BoxInfo, BoxSuccess, MnemoCallout, MnemoLoading, ModalHandler, SupportoTecnico, Title } from "components/misc";
import { examHelper, examService, learningService, networkErrorHelper } from "libs";
import { Button, Icon, Row, Col } from "design-react-kit";
import { COMPANY, REVISOR_CONTEXTS, ROUTES } from "const";
import { FormEnabler, MLabel, MTextArea, ValidatedForm } from "components/forms";

import ReactHtmlParser from "react-html-parser";
import { rc30ExamService } from "libs/api/rc30ExamService";

class CFU30ALL2UDAExamWritten extends ValidatedForm {

    excludeFromCheckUDA = ['ZOSOOIGNQ5225'];
    
  emptyFields = {
    introduzione: "",
    episodi: "",
    consoderazioni: "",
  };

  state = {
    loading: true,
    loadingError: false,
    showSuccess: false,
    ...this.emptyFields,
    defaultValues: {
      ...this.emptyFields,
    },
    examQuestion: [],
    rCode: this.props.match.params.rCode,
    exam: {},
    remoteExamSubject: {},
    examRevision: {},
    course: {},
  };

  FIELDS_GROUP = [
    [
      {
        label: "Titolo Intervento di progettazione didattica",
        for: "titolo",
        infoText:
          "Il titolo non deve essere troppo lungo e deve essere auto-esplicativo dell'intervento di progettazione didattica. Può essere accompagnato da un sottotitolo. <b>(massimo 500 battute spazi inclusi)</b>",
        component: MLabel,
        className: "col-md-12  pt-3",
      },
    ],
    [
      {
        field: "titolo",
        question: "Titolo",
        component: MTextArea,
        className: "col-md-12",
        rows: 4,
        maxLen: 500,
      },
    ],
    [
      {
        label: "Introduzione",
        for: "introduzione",
        infoText: `Questa breve sezione dovrà contenere le informazioni di contesto circa l'istituzione scolastica, l'età degli apprendenti, il livello di conoscenze/competenze, nonché altre informazioni utili a cogliere il carattere innovativo e inclusivo della progettazione didattica proposta. <b>(massimo 3000 battute spazi inclusi)</b>.`,
        component: MLabel,
        className: "col-md-12 pt-3",
      },
    ],
    [
      {
        field: "introduzione",
        question: "Introduzione",
        component: MTextArea,
        className: "col-md-12",
        rows: 10,
        maxLen: 3000,
      },
    ],
    [
      {
        label: "Progettazione di un breve percorso didattico",
        for: "progettazione",
        infoText: `In questa sezione dovrà essere progettata una lezione contenente i seguenti elementi: 
          </br>- Obiettivi di apprendimento, esplicitati dal punto di vista dell'apprendente (es. “comprendere e produrre consapevolmente i messaggi non verbali, leggendo criticamente e decodificando i propri messaggi corporei e quelli altrui”), facendo esplicito riferimento agli obiettivi specifici di apprendimento previsti nelle Indicazioni Nazionali relative alla scuola secondaria; 
          </br>- Prerequisiti, ossia le competenze che gli apprendenti dovranno aver già acquisito prima dello svolgimento del percorso didattico proposto;
          </br>- Fasi di lavoro, nelle quali si illustrerà nel dettaglio la azione svolta dall'insegnante e dagli studenti;  
          </br>- Modalità di valutazione degli obiettivi di apprendimento previsti.   
          <br/><br/><b>(massimo 6000 battute spazi inclusi)</b>.`,
        component: MLabel,
        className: "col-md-12 pt-3",
      },
    ],
    [
      {
        field: "progettazione",
        question: "Progettazione di un breve percorso didattico",
        component: MTextArea,
        className: "col-md-12",
        rows: 10,
        maxLen: 6000,
      },
    ],
    [
      {
        label: "Commento metodologico-didattico",
        for: "commento_metodologico",
        infoText: `In questa sezione il/la candidato/a dovrà esplicitare le scelte didattiche compiute ed evidenziare la solidità e la coerenza metodologica della propria progettazione, facendo esplicito riferimento a teorie, modelli e procedure didattiche acquisiti durante il Percorso Formativo. <b>(massimo 3000 battute spazi inclusi)</b>.`,
        component: MLabel,
        className: "col-md-12 pt-3",
      },
    ],
    [
      {
        field: "commento_metodologico",
        question: "Commento metodologico-didattico",
        component: MTextArea,
        className: "col-md-12",
        rows: 10,
        maxLen: 3000,
      },
    ],
  ];

  MAX_LEN = {
    titolo: 500,
    introduzione: 3000,
    progettazione: 6000,
    commento_metodologico: 3000,
  };

  ERROR_MESSAGES = {
    titolo: `Specificare l'introduzione (max ${this.MAX_LEN["introduzione"]} caratteri)`,
    introduzione: `Specificare l'introduzione (max ${this.MAX_LEN["introduzione"]} caratteri)`,
    progettazione: `Specificare la progettazione (max ${this.MAX_LEN["progettazione"]} caratteri)`,
    commento_metodologico: `Specificare il commento metodologico (max ${this.MAX_LEN["commento_metodologico"]} caratteri)`,
  };

  validation = {
    titolo: (value) => value !== "" && value.length < this.MAX_LEN["titolo"],
    introduzione: (value) =>
      value !== "" && value.length < this.MAX_LEN["introduzione"],
    progettazione: (value) =>
      value !== "" && value.length < this.MAX_LEN["progettazione"],
    commento_metodologico: (value) =>
      value !== "" && value.length < this.MAX_LEN["commento_metodologico"],
  };

  constructor(props) {
    super(props);
    // bind event handler to invoke it from child component
    this.onChange = this.onChange.bind(this);
  }

  goBack() {
    window.history.back();
  }

  onCancel = () => {
    this.setState({
      showExamSiteList: false,
      validationSummary: "",
    });

    this.resetForm();
  };

  componentDidMount() {
    this.loadRemoteDashboard(this.state.rCode);
    this.loadRemote(this.state.rCode);
  }

  loadRemote(rCode) {    
    this.setState({ loading: true, loadingError: false, rCode });
    // load paylods to fill the select options
    rc30ExamService
      .myExamSubjectUDA(rCode)
      .then(({ data }) => {
        const { examSubject } = data.payload;

        this.setState({
          remoteExamSubject: examSubject,
        });

        this.loadRemoteExam(rCode);
      })
      .catch((errors) => {
        console.log(errors);
        networkErrorHelper.notify(errors);
      });
  }

  loadRemoteDashboard(rCode) {
    learningService
      .courseDashboard(rCode)
      .then(({ data }) => {
        const { course, userCourse } = data.payload;
        this.setState({ course, userCourse });
      })
      .catch((error) => {
        if (!networkErrorHelper.is404(error)) {
          networkErrorHelper.notify(error);
        }

        this.setState({ loading: false, loadingError: true });
      });
  }

  loadRemoteExam(rCode) {
    examService
      .getExamByRCode(rCode)
      .then((data) => {
        const { exam, examQuestion, examRevision } = data.data.payload;

        let defaultValues = {};
        examQuestion.map((item) => {
          defaultValues[item.field] = item.answer;
          examQuestion[item.field] = { ...item, value: item.answer };
        });

        this.setState({
          defaultValues,
          examQuestion,
          examRevision,
          rCode,
          loading: false,
          loadingError: false,
          exam,
        });
      })
      .catch((errors) => {
        this.setState({ loading: false });
      });
  }

  /** */
  onSubmit = () => {
    this.setState({ loading: true, loadingError: false });

    /** save remote */
    this.setState({ registrationCode: this.state.rCode });
    let payload = {
      exam: {},
      examQuestion: [],
    };

    let progress = 1;

    //--- prepare examQuestion data ---
    this.FIELDS_GROUP.map((group) => {
      if (group[0].field) {
        let data = {
          field: group[0].field,
          question: group[0].question,
          answer: this.state[group[0].field]?.value || "",
          progress: progress++,
        };

        if (typeof this.state.exam.id !== "undefined") {
          const examQuestionObj = this.state.examQuestion;
          const examQuestionArray = Object.keys(examQuestionObj).map(
            (key) => examQuestionObj[key]
          );
          data.id = examQuestionArray.filter(
            (item) => item.field === group[0].field
          )[0]?.id;
        }

        payload.examQuestion.push(data);
      }
    });

    //--- handle draft mode ---
    if (typeof this.state.exam.id === "undefined") {
      payload.exam = {
        registrationCode: this.state.rCode,
        status: "draft",
        context: REVISOR_CONTEXTS.ABILITAZIONE30,
      };
      this.saveRemote(payload);
    } else {
      payload.exam = {
        ...this.state.exam,
      };

      payload.examQuestion = payload.examQuestion.map((item) => {
        const existingItem = this.state.examQuestion.find(
          (eq) => eq.field === item.field
        );

        if (existingItem) {
          if (item.answer !== "") {
            existingItem.answer = item.answer;
          } else {
            item.answer = existingItem.answer;
          }
        }

        return item;
      });

      this.setState({
        loading: false,
        loadingError: false,
      });

      this.updateRemote(payload);
    }

    setTimeout(() => {
      this.loadRemoteExam(this.state.rCode);
    }, 1000);
  };

  /** */
  saveRemote(payload) {
    examService
      .examInsert(payload)
      .then((data) => {
        this.setState({
          loading: false,
          loadingError: false,
          showSuccess: true,
          exam: { ...data.data.payload.resExam },
          examQuestion: { ...data.data.payload.resExamQuestion },
        });

        window.scrollTo({ top: 0, behavior: "smooth" });

        setTimeout(() => {
          this.setState({ showSuccess: false });
        }, 4000);
      })
      .catch((errors) => {
        console.log(errors);
        networkErrorHelper.notify(errors);
      });
  }

  updateRemote(payload) {
    examService
      .examUpdate(payload)
      .then((data) => {
        this.setState({
          loading: false,
          loadingError: false,
          showSuccess: true,
        });
        window.scrollTo({ top: 0, behavior: "smooth" });

        setTimeout(() => {
          this.setState({ showSuccess: false });
        }, 4000);
      })
      .catch((errors) => {
        console.log(errors);
        networkErrorHelper.notify(errors);
      });
  }

  confirmExam = (e, value) => {
    ModalHandler.show(
      value,
      "Conferma Elaborato",
      "Vuoi confermare l'invio dell'elaborato? La conferma dell'elaborato non potrà essere più modificata.",
      null,
      this.onConfirm,
    );
  }; //deleteRecord

  onConfirm = (value) => {
    this.setState({
      loading: true,
      loadingError: false,
    });

    let isValidForm = this.checkValidation();
    if (!isValidForm) {
      this.setState({ loading: false });
      return true;
    }

    this.onSubmit();

    examService
      .confirmRC3060AllExamWritten({
        ...this.state.exam,
        status: "confirmed",
      })
      .then((data) => {
        this.setState({
          loading: false,
          loadingError: false,
        });

        window.scrollTo({ top: 0, behavior: "smooth" });

        setTimeout(() => {
          this.setState({ showSuccess: false });
        }, 1000);

        setTimeout(() => {
          window.location.reload();
        }, 3000);
      })
      .catch((errors) => {
        console.log(errors);
        networkErrorHelper.notify(errors);
      });
  };

  //---
  downloadPDF = () => {
    const { rCode } = this.state;
    this.setState({ loading: true });

    examService
      .downloadPdfExamWritten(rCode)
      .then(({ data }) => {
        let loadingError = "";

        if (data.payload && data.payload.udaPayload) {
          window.open(data.payload.udaPayload.location, "_blank");
        } else {
          loadingError =
            "Si è verificato un errore durante l'elaborazione della richeista. Contattare il supporto tecnico. ";
        }

        this.setState({ loading: false, loadingError });
      })
      .catch((error) => {
        console.log(error);
        const requestError =
          "Si è verificato un errore durante l'elaborazione della richeista. Contattare il supporto tecnico. Dettagli errore: " +
          networkErrorHelper.getErrorMessage(error);
        this.setState({ loading: false, loadingError: requestError });
      });
  };

  renderEdit() {
    const { defaultValues, showSuccess, exam, examRevision, remoteExamSubject, rCode } = this.state;
    let isPending = false;

    // if can edit is false, render read only
    const canEdit = examHelper.canEditUDA(remoteExamSubject.dateExam, exam.status, rCode, this.excludeFromCheckUDA);

    if (!canEdit) {
      if (exam.status === "revisionPending") {
        return (
          <>
            <BoxDanger>
              Gentile Docente, poiché la prova scritta, “fondamentale per
              l'ammissione all'esame finale”, non risulta modificata a seguito
              delle indicazioni fornite dalla Commissione, siamo spiacenti di
              informarla che non potrà partecipare alla prova finale “Lezione
              simulata”, come da sua prenotazione.
              <br />
              Per eventuali chiarimenti è possibile <SupportoTecnico />
            </BoxDanger>
          </>
        );
      } else {
        return (
          <>
            <BoxDanger>
              Gentile Docente, non avendo svolto la prova scritta, fondamentale
              per l'ammissione all'esame finale, corre l'obbligo precisare che
              non potrà partecipare alla prova finale "Lezione simulata" come da
              sua prenotazione. <br />
              Per eventuali chiarimenti è possibile <SupportoTecnico />
            </BoxDanger>
          </>
        );
      }
    }

    if (exam && exam.status === "revisionPending") {
      isPending = true;
    }

    const { code } = this.renderFields(this.FIELDS_GROUP, defaultValues, true);

    return (
      <>
        <div className="container">
          {showSuccess && (
            <div className="Container">
              <BoxSuccess className="mt-4">
                Elaborato salvato con successo!
              </BoxSuccess>
            </div>
          )}
          {isPending && (
            <MnemoCallout className="mnemo-callout-danger w-100">
              <h5 className="text-red">ATTENZIONE: ELABORATO NON IDONEO</h5>
              <p>
                L'elaborato non risulta idonea. La invitiamo a modificare
                l'elaborato, nel rispetto delle motivazioni di seguito
                riportate, e premere il tasto{" "}
                <b>
                  Conferma Elaborato<b></b>
                </b>
              </p>
              <p>
                {" "}
                <i>{examRevision.revisionNote}</i>
              </p>
            </MnemoCallout>
          )}
          <form>
            {code}

            <Row className="my-5">
              <FormEnabler
                onSubmit={this.onSubmit}
                onCancel={this.onCancel}
                isFormActive={true}
                buttonText="Salva Modifiche"
              />

              {parseInt(exam.id) > 0 && (
                <Button
                  color="primary bg-dark"
                  onClick={() => {
                    this.confirmExam();
                  }}
                >
                  Consegna Elaborato
                </Button>
              )}
            </Row>
            <Row>
              <Col xs="12">
                <MnemoCallout title="Note per la compilazione">
                  <hr />
                  <ul>
                    <li>
                      Le modifiche correnti saranno salvate solo premendo il
                      tasto <b>Salva Modifiche</b>. Si possono apportare diverse
                      modifiche memorizzandole tramite il tasto{" "}
                      <b>Salva Modifiche</b> per memorizzare le modifiche
                      apportate.
                    </li>
                    <li>
                      Le modifiche salvate verranno memorizzate e sarà possibile
                      continuare la compilazione dell'elaborato anche in un
                      secondo momento.
                    </li>
                    <li>
                      Premendo il tasto <b>Consegna Elaborato</b> l'elaborato
                      verrà inviato e non potrà più essere modificato. Potrà
                      solo essere consultato e scaricato fino al giorno
                      dell'esame.
                    </li>
                    <li>
                      In caso di non idoneità dell'elaborato riceverà un avviso
                      con i motivi specifici affinché possa, tempestivamente,
                      procedere ad apportare le modifiche necessarie per rendere
                      l'elaborato idoneo alla valutazione da parte della
                      Commissione.
                    </li>
                    <li>
                      In caso di mancata consegna, entro i termini previsti
                      tramite il tasto <b>Consegna Elaborato</b> il sistema
                      acquisirà autonomamente e senza ulteriore avviso il lavoro
                      svolto fino a quel momento.
                    </li>
                  </ul>
                </MnemoCallout>
              </Col>
            </Row>
          </form>
        </div>
      </>
    );
  }

  renderRead() {
    const { examQuestion } = this.state;

    return (
      <>
        <BoxSuccess className="mt-4">
          Elaborato consegnato. Non è possibile modificare i dati.
          <Button
            onClick={this.downloadPDF}
            color="primary bg-dark"
            className="mx-5"
          >
            Scarica PDF
          </Button>
        </BoxSuccess>
        {this.FIELDS_GROUP.map((rowFields, i) => {
          return rowFields.map((field, j) => {
            if (field.for) {
              const question = examQuestion.filter(
                (item) => item.field === field.for
              )[0];

              return (
                <Row key={j}>
                  <MnemoCallout
                    className="mnemo-callout-info w-100"
                    title={field.label}
                  >
                    <p>
                      <i>{ReactHtmlParser(field.infoText)}</i>
                    </p>
                    <hr />
                    <p>{question && <>{question.answer}</>}</p>
                  </MnemoCallout>
                </Row>
              );
            }
          });
        })}
      </>
    );
  }

  renderNoteIUL() {
    return (
      <BoxInfo className="mt-4">
        <p>
          <b>
            Per la valutazione della prova scritta, la Commissione si avvarrà
            dei criteri seguenti criteri:
          </b>
        </p>
        <ul>
          <li>
            Efficacia della comunicazione formativa e didattica scritta: massimo
            PUNTI 3
          </li>
          <li>
            Completezza della descrizione degli elementi necessari alla
            progettazione didattica e/o all'Unità di Apprendimento (UDA) e/o
            alla riflessione critica ed analisi di episodi e casi osservati
            verificatisi durante il tirocinio: massimo PUNTI 2
          </li>
          <li>
            Analisi critica delle attività osservate durante l'esperienza
            formativa descritta: massimo PUNTI 3
          </li>
          <li>
            Conclusioni e possibili sviluppi di strategie innovative per il
            supporto alla didattica espressa: massimo PUNTI 2
          </li>
        </ul>
      </BoxInfo>
    );
  }

  render() {
    const { loading, loadingError, rCode, exam, course } = this.state;

    if (loading) return <MnemoLoading></MnemoLoading>;

    if (loadingError) {
      return (
        <BoxDanger className="mt-4">
          Si è verificato un errore durante il caricamento della pagina,
          <br />
          <SupportoTecnico />
        </BoxDanger>
      );
    }

    return (
      <>
        <NavLink
          to={`${ROUTES.COURSE_DASHBOARD}/${rCode}`}
          className="mx-5 btn btn-outline-primary float-right"
        >
          <Icon icon="it-presentation" />
          TORNA ALLA HOME PAGE DEL CORSO
        </NavLink>
        <Title>Prova scritta</Title>
        <hr />
        {course.instituteCompany === COMPANY.IUL && <>{this.renderNoteIUL()}</>}
        {exam && (
          <>
            {exam.status === "confirmed" || exam.status === "revisioned" ? (
              <>{this.renderRead()}</>
            ) : (
              <>{this.renderEdit()}</>
            )}
          </>
        )}
      </>
    );
  }
}

export default withRouter(CFU30ALL2UDAExamWritten);
